/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import { AnimatedNumber } from 'ui/atoms/AnimatedNumber/AnimatedNumber';
import { Flag } from 'ui/atoms/Flag/Flag';
import { Icon } from 'ui/atoms/Icon/Icon';

import styles from './MetricsTooltip.module.scss';

import { MetricsTooltipProps } from './MetricsTooltip.types';

export const MetricsTooltip = ({ flagCode, iconType, title, meta, metrics }: MetricsTooltipProps) => {
  const { t } = useInt();

  const renderVisual = () => {
    if (flagCode) {
      return <Flag code={flagCode} className={styles.tooltipFlag} />;
    }

    if (iconType) {
      return <Icon type={iconType} className={styles.tooltipIconGlyph} />;
    }

    return <Icon type="payg-51" className={styles.tooltipIconGlyph} />;
  };

  return (
    <div className={styles.tooltip}>
      <div className={styles.tooltipHeader}>
        <div className={styles.tooltipIcon}>{renderVisual()}</div>

        <div className={styles.tooltipTitleGroup}>
          <p className={styles.tooltipTitle}>{title}</p>
          <p className={styles.tooltipMeta}>{meta}</p>
        </div>
      </div>

      <div className={styles.metrics}>
        <div className={`${styles.metric} ${styles.metric_blue}`}>
          <p className={styles.metricLabel}>{t('Total companies:')}</p>
          <AnimatedNumber value={metrics.companies} duration={1000} className={styles.metricValue} />
        </div>

        <div className={`${styles.metric} ${styles.metric_yellow}`}>
          <p className={styles.metricLabel}>{t('Total contacts:')}</p>
          <AnimatedNumber value={metrics.contacts} duration={1000} className={styles.metricValue} />
        </div>

        <div className={`${styles.metric} ${styles.metric_violet}`}>
          <p className={styles.metricLabel}>{t('Accuracy rate:')}</p>
          <AnimatedNumber value={metrics.accuracy} duration={1000} suffix="%" className={styles.metricValue} />
        </div>
      </div>
    </div>
  );
};
